import React, { useState } from 'react';
import { useLazyCommand } from "@soap/modules";
import { Button } from '../../ui/button';
import { Card } from '../../ui/card';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

export function AddSectionDialog({ 
  assessmentId, 
  onClose 
}: { 
  assessmentId: string; 
  onClose: () => void;
}) {
  const [sectionTitle, setSectionTitle] = useState('');
  const [addSectionTrigger] = useLazyCommand("C189v1_AddAssessmentSection");

  const handleAdd = () => {
    addSectionTrigger({
      C189_AssessmentId: assessmentId,
      C189_SectionTitle: sectionTitle,
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-full max-w-md p-6 m-4">
        <h3 className="text-lg font-semibold mb-4">Add Section</h3>
        <div className="space-y-4">
          <div>
            <Label htmlFor="section-title">Section Title</Label>
            <Input
              id="section-title"
              value={sectionTitle}
              onChange={(e) => setSectionTitle(e.target.value)}
              placeholder="Enter section title"
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button onClick={handleAdd} disabled={!sectionTitle.trim()}>Add</Button>
          </div>
        </div>
      </Card>
    </div>
  );
}

